module.exports = __webpack_public_path__ + "static/img/ent-17.f503101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-17.jpg
// module id = DEtQ
// module chunks = 52